import React from "react";
import MapfreLogo from "src/assets/icons/mapfre_logo.png";
import { CONSTANTS_STRINGS } from "src/constants";
import packageInfo from "../../../package.json";

/**
 * Página exibida quando o link de checkout não está mais disponível
 * (API responde 200 com `available: false`) ou quando o pedido está expirado.
 */
const ExpiredLinkPage: React.FC = () => {
  return (
    <main className="relative grid min-h-dvh grid-rows-[1fr_auto] items-center gap-4 p-4">
      <article className="text-center">
        <h1 className="text-primary-1 mb-8 text-6xl font-bold md:text-7xl">
          {CONSTANTS_STRINGS.EXPIRED_LINK_TITLE}
        </h1>

        <section className="mx-auto max-w-md space-y-4">
          <h2 className="text-xl font-semibold">
            {CONSTANTS_STRINGS.EXPIRED_LINK_SUBTITLE}
          </h2>

          <p className="text-gray-600">
            {CONSTANTS_STRINGS.EXPIRED_LINK_DESCRIPTION}
          </p>
          <p className="text-gray-600">
            {CONSTANTS_STRINGS.EXPIRED_LINK_FOOTER}
          </p>
        </section>
      </article>

      <footer className="flex justify-center">
        <img src={MapfreLogo} alt="Mapfre" />
      </footer>
      <span className="absolute right-0 bottom-0.5 left-0 text-center text-[10px] text-gray-400">
        v{packageInfo.version}
      </span>
    </main>
  );
};

export default ExpiredLinkPage;
